<template>
  <div class="product-info">
    <b-container>
      <b-row>
        <b-col sm="3" class="p-2">ステータス:</b-col>
        <b-col sm="9" class="p-2">{{ labels.status[info.status] }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">種別:</b-col>
        <b-col sm="9" class="p-2">{{ labels.type[info.type] }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">シリアルNo.:</b-col>
        <b-col sm="9" class="p-2">{{ info.id }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">メーカー名:</b-col>
        <b-col sm="9" class="p-2">{{ info.maker }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">商品名:</b-col>
        <b-col sm="9" class="p-2">{{ info.name }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">CAS No.:</b-col>
        <b-col sm="9" class="p-2">{{ info.cas_no }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">FEMA No.:</b-col>
        <b-col sm="9" class="p-2">{{ info.fema_no }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">入目:</b-col>
        <b-col sm="9" class="p-2">{{ info.pieces }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">数量:</b-col>
        <b-col sm="9" class="p-2">{{ info.nums }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">メモ欄:</b-col>
        <b-col sm="9" class="p-2">{{ info.synonym }}</b-col>
      </b-row>
      <b-row v-if="auth.level >= 2">
        <b-col sm="3" class="p-2">ユーザー名:</b-col>
        <b-col sm="9" class="p-2">{{ info.user_name }}</b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">公開日時:</b-col>
        <b-col sm="9" class="p-2">
          <span v-if="info.published_at !== null">
            {{ $date(info.published_at).format('YYYY年MM月DD日 HH時mm分') }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">更新日時:</b-col>
        <b-col sm="9" class="p-2">
          <span v-if="info.updated_at !== null">
            {{ $date(info.updated_at).format('YYYY年MM月DD日 HH時mm分') }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="3" class="p-2">添付ファイル:</b-col>
        <b-col sm="9" class="p-2">
          <b-table
            thead-class="uploads-thead"
            striped
            hover
            stacked="md"
            head-variant="light"
            primary-key="id"
            :items="uploads"
            :fields="uploadFields"
          >
            <template #cell(download)="data">
              <b-link :href="'/uploads/'+data.item.filename" download>
                ファイル{{ data.index + 1 }}
              </b-link>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ProductInfo',

  data() {
    return {
      labels: {
        status: { draft: '下書き', public: '公開中', finish: '済', cancel: '取消' },
        type: { sell: '売りたい', buy: '買いたい' },
      },
      uploadFields: [
        'download',
      ],
    };
  },

  computed: {
    ...mapState({
      info: state => state.products.info,
      uploads: state => state.products.uploads,
      auth: state => state.auth,
    }),
  },

  mounted() {
    this.$store.dispatch('products/uploads', this.$route.params.id);
  },
};
</script>

<style scoped>
</style>

<style>
.uploads-thead {
  display: none;
}
</style>
